<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import { DefaultStep } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import data  from "../../../Data/BonusUi/BonusUi.json"
</script>
<Col sm="12">
  <Card cardHeaderprops="pb-0" headerTitle={DefaultStep}>
    <div slot="contentbody">
      <Row class="u-steps">
        {#each data.defaultstepdata as stepItem}
          <Col sm="4" class="u-step {stepItem.class}">
            <span class="u-step-number">{stepItem.num}</span>
            <div class="u-step-desc">
              <span class="u-step-title">{stepItem.title}</span>
              <p>{stepItem.content}</p>
            </div>
          </Col>
        {/each}
      </Row>
    </div>
  </Card>
</Col>